import {KanbanUser} from '../types/KanbanUser';
import {getWatchedUserColor} from './getWatchedUserColor';

export function getCardOwner(
  selectedUsers: KanbanUser[],
  ownerId: string
): {fullName: string; color: string} | null {
  const ownerIndex = selectedUsers.findIndex((user) => user.id === ownerId);

  if (ownerIndex === -1) {
    return null;
  }

  return {fullName: selectedUsers[ownerIndex].fullName, color: getWatchedUserColor(ownerIndex)};
}
